import { Injectable } from '@angular/core';
import { map, switchMap, tap } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private readonly httpService: AmplifyHttpClient) {}
  profilePic(request) {
    const data = {
      file: request.file.split(';')[0],
      type: request.type,
    };

    return this.httpService.post<any>(`api/file-upload/request-profile-url`, data).pipe(
      map((response) => {
        //upload img to s3
        return this.uploadfiletoS3(request.file.replace(/^data:image\/\w+;base64,/, ''), response.data.upload_url);
      })
    );
  }
  assetMapPic(request) {
    const data = {
      file: request.file.split(';')[0],
      type: request.type,
      ...request.node,
    };

    return this.httpService.post<any>(`api/report/asset-map-owners-profile`, data).pipe(
      map((response) => {
        return this.uploadfiletoS3(request.file.replace(/^data:image\/\w+;base64,/, ''), response.data);
      })
    );
  }

  postPic(request) {
    return this.httpService.post<any>(`api/file-upload/posts`, request).pipe(
      map((response) => {
        return response;
      })
    );
  }

  messagePic(request) {
    return this.httpService.post<any>(`api/file-upload/message`, request).pipe(
      map((response) => {
        return response;
      })
    );
  }

  infoPic(request, param) {
    const data = {
      file: request.file.split(';')[0],
      type: request.type,
    };
    return this.httpService.post<any>(`api/file-upload/request-${param}-url`, data).pipe(
      map(async (response) => {
        //upload img to s3
        await this.uploadfiletoS3(request.file.replace(/^data:image\/\w+;base64,/, ''), response.data.upload_url);
        return response;
      })
    );
  }

  async uploadfiletoS3(file, uploadURL) {
    await new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadURL, true);
      xhr.setRequestHeader('Content-Type', 'image');
      xhr.send(Buffer.from(file, 'base64'));
      xhr.onload = () => {
        if (xhr.readyState === xhr.DONE) {
          resolve(null);
        }
      };
    });
  }
  guardianImage(request) {
    const data = {
      user_id: request.user_id,
      img_type: request.img_type,
    };
    return this.httpService.post<any>(`api/user/guardian-user-request-profile-url`, data).pipe(
      map((response) => {
        return this.uploadfiletoS3(request.file.replace(/^data:image\/\w+;base64,/, ''), response.data);
      })
    );
  }
  vaultFOrmImage(request) {
    const data = {
      vault_user_form_id: request.vaultId,
      file_name: request.fileName,
      type: request.type,
    };
    return this.httpService.post<any>(`api/vault/form-upload-profile`, data).pipe(
      map(async (response) => {
        if (response) {
          await this.uploadfiletoS3(request.file.replace(/^data:image\/\w+;base64,/, ''), response.data);
          return this.httpService.patch(`api/vault/form-upload-profile`, data);
        }
      })
    );
  }

  getVaultFormImage(userId, formId) {
    return this.httpService.get(`api/vault/form-upload-profile/${userId}/${formId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  companyLogoPic(request) {
    const data = {
      file: request.file.split(';')[0],
      type: request.type,
    };

    return this.httpService.post<any>(`api/file-upload/company-logo-url`, data).pipe(
      map((response) => {
        //upload img to s3
        return this.uploadfiletoS3(request.file.replace(/^data:image\/\w+;base64,/, ''), response.data.upload_url);
      })
    );
  }
}
